
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/universities/[universitySlug]/societies",
      function () {
        return require("private-next-pages/universities/[universitySlug]/societies/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/universities/[universitySlug]/societies"])
      });
    }
  